import React, { useEffect } from "react"
import { DateTime } from "luxon";
import classNames from "classnames"

// import { Handle, Remove } from "./components"

import './BoardItem.scss';
import { userColor, userInitials } from "../../utils/userUtils";

const BoardItem = React.memo(React.forwardRef(({ dragOverlay, dragging, user, disabled, fadeIn, handle, handleProps, height, index, listeners, onRemove, renderItem, sorting, style, transition, transform, value, wrapperStyle, item, lead, onClickItem, ...props }, ref) => {
  useEffect(() => {
    if (!dragOverlay) return;

    document.body.style.cursor = "grabbing";

    return () => {
      document.body.style.cursor = "";
    }
  }, [dragOverlay]);

  if (!lead) {
    return <div>{ value }</div>
  }

  const leadDate = DateTime.fromISO(lead?.date_added);
  const leadName = lead.full_name || `${lead.first_name} ${lead.last_name}`;

  if (renderItem) {
    return renderItem({ dragOverlay: Boolean(dragOverlay), dragging: Boolean(dragging), sorting: Boolean(sorting), index, fadeIn: Boolean(fadeIn), listeners, ref, style, transform, transition, value })
  }
  
  const itemStyle = {
    ...wrapperStyle,
    transition      : [transition, wrapperStyle?.transition].filter(Boolean).join(", "),
    "--translate-x" : transform ? `${Math.round(transform.x)}px` : undefined,
    "--translate-y" : transform ? `${Math.round(transform.y)}px` : undefined,
    "--scale-x"     : transform?.scaleX ? `${transform.scaleX}`  : undefined,
    "--scale-y"     : transform?.scaleY ? `${transform.scaleY}`  : undefined,
    "--index"       : index,
  }

  const showIds = localStorage.getItem('pl__dev_show_kanban_ids') === 'true';

  return (
    <li className={classNames('__kanban-item-wrapper', { fadeIn, sorting, dragOverlay })} style={itemStyle} ref={ref} onClick={() => onClickItem(lead)}>
      <div className={classNames('__kanban-item', { dragging, withHandle: handle, dragOverlay, disabled })} style={style} {...(!handle ? listeners : undefined)} {...props} tabIndex={!handle ? 0 : undefined}>
        <div className='content'>
          <div className="name-user">
          <div className="name-email">
            <div className='name'>{ leadName }</div>
            <div className='email'>{ lead.email }</div>
          </div>
          { user && <div className='assigned-user' style={{ backgroundColor: userColor(user).code }}>{ userInitials(user) }</div> }
          </div>
          <div className='date'>Added { leadDate.toLocaleString(DateTime.DATE_MED) }</div>
          
          { showIds && (
            <>
              <div style={{ position: 'absolute', bottom: 6, right: 8, fontFamily: 'monospace', fontSize: 10, color: "blueviolet" }}>{ lead.order_index }</div>
              <div style={{ position: 'absolute', bottom: 24, right: 8, fontFamily: 'monospace', fontSize: 10, color: "gray" }}>{ lead.id }</div>
            </>
          )}
        </div>
      </div>
    </li>
)}));

export default BoardItem;
